<template>
  <div id="sincerity">
    <div class="tabbar">
      <div
        :class="item === selectItem ? 'isAcitve' : ''"
        v-for="(item, index) in tabbarItem"
        :key="index"
        @click="clickItem(item, index)"
      >
        {{ item }}
      </div>
    </div>
    <div class="filter">
      <div class="select_ground">
        <div class="select_data">
          <el-select
            v-model="query.type"
            :popper-append-to-body="false"
            placeholder="选择时间"
            @change="handleSearch(1)"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="select_game">
          <el-select
            v-model="query.game_id"
            clearable
            filterable
            :popper-append-to-body="false"
            placeholder="全部游戏"
            @change="handleSearch(1)"
          >
            <el-option
              v-for="(item, index) in selectGame"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- <div class="filter_search">
        <input
          type="text"
          class="filter_search_input"
          v-model="query.keyword"
          placeholder="请输入账户关键词"
        />
        <span class="filter_search_btn" @click="handleSearch">确认</span>
      </div> -->
    </div>
    <div class="product_list">
      <el-table :data="tableData" style="width: 100%">
        <!-- 空数据 -->
        <template slot="empty">
          <div class="no_data">
            <empty-state
              title="暂无服务订单"
              description="可以调整筛选条件后再次查看"
              icon="el-icon-document-checked"
              :icon-size="52">
            </empty-state>
          </div>
        </template>
        <!-- 商品信息 -->
        <el-table-column
          :label="'商品信息（' + totalCount + '条）'"
          width="320"
        >
          <template slot-scope="scope">
            <div class="product">
              <div class="product__img" v-if="scope.row.serve_id == 1">
                <img src="@/assets/image/AllGame/selectGame/chengxinmaiIcon.png" alt="">
              </div>
              <div class="product_info">{{scope.row.serve_name}}</div>
            </div>
          </template>
        </el-table-column>
        <!-- 游戏名称 -->
        <el-table-column label="游戏名称">
          <template slot-scope="scope">
            <div>{{ scope.row.game_name }}</div>
          </template>
        </el-table-column>
        <!-- 游戏账号 -->
        <el-table-column label="商品编号">
          <template slot-scope="scope">
            <div>{{ scope.row.unique_no }}</div>
          </template>
        </el-table-column>
        <!-- 金额 -->
        <el-table-column label="金额">
          <template slot-scope="scope">
            <div class="product_price">¥{{ scope.row.serve_amount }}</div>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column label="状态" width="140">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag
                v-if="scope.row.status == 1"
                type="danger"
                size="medium"
                >待付款</el-tag
              >
              <el-tag
                v-if="scope.row.status == 4"
                type="danger"
                size="medium"
                >退款中</el-tag
              >
              <!-- <el-tag
                v-if="scope.row.status == '2'"
                type="error"
                size="medium"
                >待发货</el-tag
              > -->
              <el-tag
                v-if="scope.row.status == 2"
                type="success"
                size="medium"
                >已完成</el-tag
              >
              <el-tag
                v-if="scope.row.status == 5"
                type="success"
                size="medium"
                >已退款</el-tag
              >
              <el-tag
                v-if="scope.row.status == 3"
                type="info"
                size="medium"
                >已取消</el-tag
              >
            </div>
            <div class="pay_count_down" v-if="scope.row.expire_time>nowTime&&scope.row.status == 1">
              <img src="@/assets/image/PersonalCenter/Seller/payIcon.png" alt="">
              支付倒计时
              <count-down
                class="count_down"
                style="margin: 0 0 0 3px"
                :key="scope.row.id"
                :endTime="scope.row.expire_time"
                :startTime="scope.row.add_time"
                format="ms"
                @countDownChange="countDownChange($event, scope.row)"
              ></count-down>
            </div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作" width="110">
          <template slot-scope="scope">
            <div class="btn_ground">
              <div
                v-if="scope.row.status == 1"
                class="confirmReceipt"
                @click.stop="goPayment(scope.row)"
              >
                去支付
              </div>
              <div
                class="ask_service"
                @click.stop="goDetail(scope.row)"
              >
              支付详情
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages" v-if="totalCount !== 0">
        <common-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="query.page"
          :page-size="query.pageSize"
          layout="prev, pager, next, jumper"
          :total="totalCount"
        >
        </common-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  apiGameList,
  apiGetServicesList,
  apiPaypayserve,
  apiOrderCancel,
  apiPaySwitch
} from "@/request/API";
import countDown from "@/components/countDown";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";

export default {
  name: "SincerityList",
  props: {},
  components: {
    countDown,
    CommonPagination,
    EmptyState,
  },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
        status: 0,
        type: 0,
        game_id: "",
      },
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 0,
      // tabbar 选中项
      selectItem: "全部",
      // tabbar 选中项Index
      selectItemIndex: 0,
      tabbarItem: ["全部", "待付款", "已完成", "已取消", "退款中", "已退款"],
      //表格数据
      tableData: [],
      //选择时间下拉框
      options: [
        { value: 0, label: "全部" },
        { value: 1, label: "本周内" },
        { value: 2, label: "当月" },
        { value: 3, label: "三个月内" },
        { value: 4, label: "半年内" },
        { value: 5, label: "半年以上" },
        { value: 6, label: "一年内" },
      ],
      //选择游戏下拉框
      selectGame: [],
      selectGameValue: "",
      nowTime: Math.floor(new Date().getTime()/1000)
    };
  },
  methods: {
    /**
     *
     * @param countDown Boolean 是否超时
     * @param row 行数据
     */
    countDownChange(countDown, row) {
      // if (countDown) {
      //   apiOrderCancel({
      //     id: row.one_order_info.order_id,
      //   })
          // .then((res) => {
            this.nowTime = Math.floor(new Date().getTime()/1000)
            this.handleSearch(this.query.page);
          // })
          // .catch((e) => {
          //   this.$message({
          //     type: "error",
          //     center: true,
          //     message: e.msg,
          //   });
          // });
      // }
    },
    /**
     * @description: 跳转详情
     * @return {*}
     */
    goDetail(row) {
      this.$router.push({
        name: "SellerSincerityDetail",
        query: {
          id: row.id,
        },
      });
    },
    //table监听事件
    handleEdit(index, row) {},
    handleCurrentChange(val) {
      this.query.page = val;
      this.handleGetData();
    },
    handleSearch(page) {
      this.query.page = 1;
      if (page) {
        this.query.page = page;
      }
      this.handleGetData();
    },
    handleGetData() {
      apiGetServicesList(this.query).then((res) => {
        this.tableData = res.data.list;
        this.totalCount = res.data.total;
      });
    },
    //tabbar
    clickItem(item, index) {
      this.selectItem = item;
      this.query.status = index;
      this.handleSearch();
    },
    /**
     * 去支付按钮点击事件
     * @param data
     */
    goPayment(row) {
      this.$router.push({
        name: 'MethodOfPayment',
        query: {
          type: 2,
          orderid: row.id,
          id: row.product_id,
          gameid: row.game_id,
          uniqueno: row.unique_no,
          amount: row.serve_amount
        }
      })
/*      apiPaySwitch({
        game_id: row.game_id,
        type: 2
      }).then(res => {
        if(res.data.is_lianlian_pay == 1){
          this.$router.push({
            name: 'MethodOfPayment',
            query: {
              type: 2,
              orderid: row.id,
              id: row.product_id,
              gameid: row.game_id,
              uniqueno: row.unique_no,
              amount: 10
            }
          })
        } else {
          apiPaypayserve({
            id: row.id,
            return_url:`${process.env.VUE_APP_WEBSITE}/sinceritypayment?orderid=${row.id}&id=${row.product_id}&gameid=${row.game_id}&uniqueno=${row.unique_no}`
          }).then(response=>{
            const div = document.createElement("divform");
            div.innerHTML = response.data.from_data
            document.body.appendChild(div);
            document.forms[0].acceptCharset = "GBK"; // 保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
            document.forms[0].submit();
            div.remove();
          }).catch(e => {
            this.$message.error(e.msg)
          })
        }
      })*/
    },
  },
  created() {
    apiGameList().then((res) => {
      res.data.forEach((item, index) => {
        let options = new Object();
        options.value = item.game_id;
        options.label = item.game_name;
        this.selectGame.push(options);
      });
    });
    this.$WS.on('pc_alipay_serve_success',() => {
      this.handleGetData()
    })
  },
  mounted() {
    //初始化数据
    // if (typeof this.$route.params.selectItem !== "undefined") {
    //   this.clickItem(
    //     this.$route.params.selectItem,
    //     this.$route.params.selectItemIndex
    //   );
    // } else {
      // this.onLoad()
      this.handleGetData();
    // }
  },
  watch: {},
  computed: {},
};
</script>

<style lang='less'>
.change_price_confirm {
  width: 500px !important;
  height: 320px !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  padding: 0;
  border: none;

  .el-message-box__header > .el-message-box__title {
    display: none;
  }

  .el-message-box__header,
  .el-message-box__content {
    display: flex;
    flex-direction: column;
    padding: 0 0 0 70px;
  }

  .el-message-box__btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .el-message-box__title {
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #5b5b5b;
    line-height: 28px;
  }

  .el-message-box__container {
    margin-top: 34px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5b5b5b;
    line-height: 22px;
  }

  .change_price_confirm_btn {
    margin-top: 20px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 3px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }

  .change_price_confirm_btn:hover {
    background: var(--primary-hover, #E84A12) !important;
  }

  .confirm_content {
    display: flex;
    flex-direction: column;
  }

  .confirm_original_price {
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #fc4a00;
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_my_bid {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5b5b5b;
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_modify_bid {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .confirm_modify_bid_text {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5b5b5b;
    line-height: 28px;
  }

  .confirm_modify_bid_input {
    width: 210px;
    height: 40px;
    background: #f9f9f9;
    border-radius: 4px;
    border: 1px solid #f0f0f0;
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }

  .confirm_modify_bid_tips {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #bfbfbf;
    line-height: 22px;
    margin-left: 100px;
  }

  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #d1d1d1;
  }
}
</style>

<style lang='less' scoped>
#sincerity {
  min-height: 620px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .tabbar {
    min-height: 40px;
    height: auto;
    margin-top: 0;
    padding: 4px 0 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    border: none;
    border-radius: 0;
    overflow: visible;

    div {
      min-width: 76px;
      height: 34px;
      margin-right: 0;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;
      cursor: pointer;
      transition: color .2s ease, background .2s ease, box-shadow .2s ease;
    }

    div:hover {
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    .isAcitve,
    .isAcitve:hover {
      padding-bottom: 0;
      color: #FFFFFF;
      font-size: 14px;
      font-weight: 500;
      background: var(--bg-dark, #1A1D24);
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
    }
  }

  .filter {
    min-height: 40px;
    height: auto;
    margin: 18px 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    background: transparent;
    border: none;
    border-radius: 0;

    .select_ground {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;

      /deep/ .el-input__inner {
        width: 180px;
        height: 40px;
        padding: 0 34px 0 14px;
        background: var(--bg-card, #FFFFFF);
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        color: var(--text-main, #111827);
        font-size: 14px;
        transition: border-color .2s ease, box-shadow .2s ease;
      }

      /deep/ .el-input.is-focus .el-input__inner,
      /deep/ .el-input__inner:focus {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      /deep/ .popper__arrow {
        left: 155px !important;
      }

      /deep/ .el-select-dropdown {
        border-color: var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      }

      /deep/ .el-select-dropdown__item {
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/ .el-select-dropdown__item.hover,
      /deep/ .el-select-dropdown__item:hover {
        background: var(--bg-tag, #F0EDE8);
      }

      /deep/ .el-select-dropdown__item.selected {
        color: var(--primary, #FF5A1F);
        font-weight: 500;
      }

      .select_data {
        margin-right: 0;
      }
    }

    .filter_search {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;

      .filter_search_input {
        width: 160px;
        height: 40px;
        background: #f4f4f4;
        border-radius: 4px;
        border: none;
        padding: 0 120px 0 20px;
        font-size: 16px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
      }

      .filter_search_input::-webkit-input-placeholder {
        font-size: 16px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: #cecece;
      }

      .filter_search_btn {
        position: absolute;
        top: 0;
        left: 200px;
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }

  .product_list {
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);

    /deep/ .el-table {
      color: var(--text-main, #111827);
    }

    /deep/ .el-table:before {
      display: none;
    }

    /deep/ .el-table th {
      height: 48px;
      background: var(--bg-tag, #F7F5F2);
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-secondary, #5A5F6B);
    }

    /deep/ .el-table th > .cell,
    /deep/ .el-table .cell {
      padding: 0;
      text-align: center;
    }

    /deep/ .el-table td {
      padding: 0;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
    }

    /deep/ .el-table__row:hover td {
      background: var(--bg-tag, #F7F5F2);
    }

    /deep/ .el-tag {
      height: 28px;
      padding: 0 10px;
      display: inline-flex;
      align-items: center;
      border: none;
      border-radius: 4px;
      background: var(--bg-tag, #F0EDE8);
      color: var(--text-main, #1A1D24);
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
    }

    /deep/ .el-tag.el-tag--danger {
      background: var(--primary-soft, #FCEDE5);
      color: var(--hot, #FF2D55);
    }

    /deep/ .el-tag.el-tag--info {
      background: var(--bg-tag, #F0EDE8);
      color: var(--text-muted, #9AA0AC);
    }

    /deep/ .el-tag.el-tag--success {
      background: var(--primary-soft, #FCEDE5);
      color: var(--new, #00C16E);
    }

    /deep/ .el-tag.el-tag--warning {
      background: var(--primary-soft, #FCEDE5);
      color: var(--primary, #FF5A1F);
    }

    .product {
      height: 96px;
      padding: 18px 0 18px 18px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .product__img {
        width: 76px;
        height: 48px;
        margin-right: 14px;
        flex: 0 0 76px;
        overflow: hidden;
        background: var(--bg-tag, #F0EDE8);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;

        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        /deep/ .el-image {
          height: 100%;
          width: 100%;
          object-fit: cover;
          border-radius: 4px;
        }
      }

      .product_info {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
        font-size: 15px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        color: var(--text-main, #111827);
        line-height: 22px;
      }

    }
    .pay_count_down {
      min-width: 116px;
      min-height: 24px;
      margin-top: 8px;
      padding: 0 8px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      background: var(--primary-soft, #FCEDE5);
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--gold, #C9974D);
      line-height: 18px;
      white-space: nowrap;
      img {
        margin-right: 4px;
        width: 16px;
        height: 16px;
      }
    }

    .product_price {
      font-size: 20px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 600;
      color: var(--primary, #FF7A1A);
      line-height: 28px;
    }

    .btn_ground {
      padding: 0 10px;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 8px;

      div,
      a {
        height: 30px;
        min-width: 72px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        line-height: 18px;
        text-decoration: none;
        cursor: pointer;
        transition: color .2s ease, background .2s ease, border-color .2s ease, box-shadow .2s ease, opacity .2s ease;
      }

      .confirmReceipt {
        background: var(--primary, #FF5A1F);
        border: none;
        color: #FFFFFF;
        box-shadow: none;
      }

      .confirmReceipt:hover {
        opacity: 1;
        background: var(--primary-hover, #E84A12);
        box-shadow: none;
      }

      .ask_service {
        margin: 0;
        background: var(--bg-card, #FFFFFF);
        border: 1.5px solid var(--bg-dark, #1A1D24);
        color: var(--text-main, #1A1D24);
      }

      .ask_service:hover {
        background: var(--bg-tag, #F0EDE8);
      }
    }

    .pages {
      min-height: 88px;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bg-card, #FFFFFF);
    }

    .no_data {
      min-height: 300px;
      padding: 64px 36px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .confirmReceip-btnGroup {
    display: flex;
    align-items: center;
    justify-content: center;

    div {
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #1A1D24);
      width: 138px;
      height: 38px;
      border-radius: 4px;
      opacity: 1;
      border: 1.5px solid var(--bg-dark, #1A1D24);
      cursor: pointer;
      user-select: none;
      text-align: center;
      line-height: 38px;
    }

    div:last-of-type {
      background: var(--primary, #FF5A1F);
      border: 1px solid var(--primary, #FF5A1F);
      color: #FFFFFF;
      margin: 0 0 0 15px;
    }
  }
}
</style>
